import {
	AUTH,
} from '../constants';

const initialState = {
	authProvider: null,
	authStatus: AUTH.NONE,
	email: null,
	listeningToAuth: false,
	photoURL: null,
	uid: null,
	userName: null,
	observers : {}
};

export default function(currentState = initialState, action){
	switch(action.type) {

	case AUTH.LOGIN_REQUEST:
		return {
			...currentState,
			authStatus: AUTH.LOGIN_REQUEST
		};
	case AUTH.LOGGED_IN:
		return {
			...currentState,
			authStatus: AUTH.LOGGED_IN,
			userName: action.payload.user.displayName,
			uid: action.payload.user.uid
		};
    
	case AUTH.LOGGED_OUT:
		return {
			...currentState,
			authStatus: AUTH.LOGGED_OUT,
			userName: null,
			uid: null
		};
	case AUTH.SET_AUTH_OBSERVER:
	{
		let {observers} = currentState;
		if(action.payload.observerId){
			observers[action.payload.observerId] = action.payload.observer;
		}
		return {
			...currentState,
			observers
		};
	}
	default:
		return currentState;
	}
}